import { AccountTree, Add } from "@mui/icons-material";
import { AlertColor, Box, Button, Divider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ValidationRuleModalDeleteComp } from "../ModalDeleteValidationRule/ValidationRuleModalDeleteComp";
import ValidationRuleListComp from "./ValidationRuleListComp";
import KeydriveSnackbar from "../../../components/KeydriveComponents/Snackbar/KeydriveSnackbar";
import { KeyDrivePageContainer } from "../../../components/KeydriveComponents/PageContainer/KeyDrivePageContainer";

const ValidationRuleList = (props: any) => {

  const { t } = useTranslation();
  const [findValidationRule, setFindValidationRule] = useState<string>("");
  const iconProps = { iconName: "Filter" };
  const [popupOk, setPopupOk] = useState<boolean>(false);
  const { idWorkspace } = useParams();
  const { nameOrg } = useParams();
  const navegate = useNavigate();
  const [idVrDelete, setIdVrDelete] = useState<string | undefined | number>(0);
  const [reload, setReload] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedItemId, setSelectedItemId] = useState<string | undefined>(undefined);
  const [severity, setSeverity] = useState<AlertColor>("success");
  const [message, setMessage] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (reload == true) {
      setReload(false);
    }
  }, [reload]);

  const onChangeSetFindValidationRule = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    if (newValue != undefined) {
      setFindValidationRule(newValue);
    }
    else {
      setFindValidationRule("");
    }
  };

  const handleClose = () => {
    setMessage(undefined);
  }

  const handleClosePO = (event: any) => {
    setPopupOk(false);
  }

  const onClickNew = () => {
    navegate(`/${nameOrg}/${idWorkspace}/validationRule/new`);
  };

  const toggleDelete = (
    value: string | undefined
  ) => {
    if (value == idVrDelete) {
      if (idVrDelete != undefined) {
        setShowModal(true);
      }
    }
    else {
      setIdVrDelete(value!);
    }
  };

  useEffect(() => {
    if (typeof idVrDelete != "number") {
      setShowModal(true);
    }
  }, [idVrDelete]);

  const onClickDelete = (
    event: React.FormEvent<HTMLElement>
  ) => {
    const { myValue } = event.currentTarget.dataset;
    toggleDelete(myValue);
  };

  const onCloseModal = () => {
    setShowModal(false)
    setReload(true);
  }

  return (
    <KeyDrivePageContainer
      icon={<AccountTree fontSize='large' sx={{ color: "#22638D" }} />}
      title={t("ValidationRule.ValidationruleListTitle")}
      subtitle={t("ValidationRule.ValidationRuleListDescription")}
      actions={<Button
        startIcon={<Add />}
        sx={{
          background: "#22638D 0% 0% no-repeat padding-box",
          borderRadius: "4px",
          opacity: 1,
          ":hover": {
            background: "#22638D 0% 0% no-repeat padding-box",
            borderRadius: "4px",
            opacity: 1,
          }
        }}
        variant="contained"
        onClick={onClickNew}
      >
        <Typography
          textTransform="none"
          sx={{
            textAlign: "left",
            font: "normal normal normal 14px/21px Segoe UI",
            letterSpacing: "0px",
            color: "#FFFFFF",
            opacity: 1,
          }}
        >
          {t("ValidationRule.ValidationRuleListCreateButton")}
        </Typography>
      </Button>}
      divider>
        
      <ValidationRuleModalDeleteComp onClose={() => onCloseModal()} show={showModal} idVrDelete={selectedItemId} setMessage={setMessage} setSeverity={setSeverity} />

      {reload == false && idWorkspace != undefined && nameOrg != undefined ?
        (
          <ValidationRuleListComp
            nameOrg={nameOrg}
            idWorkspace={idWorkspace}
            text={findValidationRule}
            onClickExcluir={onClickDelete}
            toggleDelete={toggleDelete}
            idVrDelete={idVrDelete as string}
            selectedItemId={selectedItemId!}
            setSelectedItemId={setSelectedItemId}
          />
        ) :
        (<div></div>)}
      <KeydriveSnackbar
        open={message != undefined}
        variant={severity}
        message={message}
        onClose={handleClose}
      />
    </KeyDrivePageContainer>
  );
}

export default ValidationRuleList;